var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "plan-modal default-bkg p-2 pb-5 lh-reset" },
    [
      _c("h3", { staticClass: "mt-2 mb-2" }, [
        _vm._v(_vm._s(_vm.$l10n.__("Paramétrage")))
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex-level well" },
        [
          _c("p", { staticClass: "m-0" }, [
            _vm._v(
              _vm._s(
                _vm.$l10n.__("Accéder aux paramètres de votre plan de relance")
              )
            )
          ]),
          _vm._v(" "),
          _c("CompassButton", {
            staticClass: "flex-item-right",
            attrs: {
              label: _vm.$t.__("preferences.Dunning.Plan.setting_access"),
              type: "secondary",
              loading: _vm.loading
            },
            on: {
              click: function($event) {
                _vm.planSettingVisible = true
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("CompassDialog", {
        attrs: {
          visible: _vm.planSettingVisible,
          size: "large",
          title: _vm.$t.__("preferences.Dunning.Plan.setting")
        },
        on: {
          "update:visible": function($event) {
            _vm.planSettingVisible = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__default" },
                  [
                    _c("p", { staticClass: "m-0" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Nom de ma relance")))
                    ]),
                    _vm._v(" "),
                    _c("el-input", {
                      staticClass: "w-4",
                      model: {
                        value: _vm.currentName,
                        callback: function($$v) {
                          _vm.currentName = $$v
                        },
                        expression: "currentName"
                      }
                    }),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-1 mt-5" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Jours d'émission des envois de relance"
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c("span", { staticClass: "grey mb-3 block" }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              "Attention ce paramètre peut créer des décalages dans l'envoi des emails."
                            )
                          ) +
                          "\n                "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-checkbox-group",
                      {
                        model: {
                          value: _vm.formWeekdays,
                          callback: function($$v) {
                            _vm.formWeekdays = $$v
                          },
                          expression: "formWeekdays"
                        }
                      },
                      _vm._l(_vm.weekDays, function(weekday) {
                        return _c(
                          "el-checkbox",
                          {
                            key: weekday.binary,
                            attrs: { label: weekday.binary }
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(weekday.weekDay) +
                                "\n                    "
                            )
                          ]
                        )
                      }),
                      1
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "mb-1 mt-5" }, [
                      _vm._v(_vm._s(_vm.$l10n.__("Choix de la plage horaire")))
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex-level" },
                      [
                        _c("span", { staticClass: "mr-3" }, [
                          _vm._v(
                            _vm._s(_vm.$l10n.__("Envoyer les emails entre"))
                          )
                        ]),
                        _vm._v(" "),
                        _c("el-time-select", {
                          staticClass: "w-100",
                          attrs: {
                            placeholder: "Start time",
                            pickerOptions: {
                              start: "00:00",
                              step: "01:00",
                              end: "23:00",
                              maxTime: _vm.endTime
                            }
                          },
                          model: {
                            value: _vm.startTime,
                            callback: function($$v) {
                              _vm.startTime = $$v
                            },
                            expression: "startTime"
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "mx-3" }, [
                          _vm._v(_vm._s(_vm.$l10n.__("et")))
                        ]),
                        _vm._v(" "),
                        _c("el-time-select", {
                          staticClass: "w-100",
                          attrs: {
                            placeholder: "End time",
                            pickerOptions: {
                              start: "00:00",
                              step: "01:00",
                              end: "23:00",
                              minTime: _vm.startTime
                            }
                          },
                          model: {
                            value: _vm.endTime,
                            callback: function($$v) {
                              _vm.endTime = $$v
                            },
                            expression: "endTime"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.doctype == "invoice"
                      ? _c("dunning-enable", {
                          staticClass: "my-5",
                          attrs: {
                            enabled: _vm.currentRecurring,
                            enableLabel: _vm.$t.__(
                              "preferences.Dunning.activated"
                            ),
                            disableLabel: _vm.$t.__(
                              "preferences.Dunning.disabled"
                            ),
                            description: _vm.$t.__(
                              "preferences.Dunning.Plan.activate_dunning_invoice_subscription"
                            )
                          },
                          on: {
                            "update:enabled": function($event) {
                              _vm.currentRecurring = $event
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "well fs-3 p-3 my-5" },
                      [
                        _c("CompassNumberInput", {
                          staticClass: "fright mt-2 p-0 custom-numbertinput",
                          attrs: {
                            modelValue: _vm.currentGap,
                            min: 1,
                            max: 15,
                            step: 1
                          },
                          on: {
                            change: function(newGap) {
                              return (_vm.currentGap = newGap)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "m-0" }, [
                          _c("span", { staticClass: "semibold mt-2" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Nombre de jours minimum entre deux relances"
                                  )
                                ) +
                                " "
                            )
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c("p", { staticClass: "grey mt-1 mb-0 wp-6" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$l10n.__(
                                    "Ce paramètre permet d'éviter de multiples relances sur la période indiquée si le plan de relance est par exemple modifié."
                                  )
                                ) +
                                "\n                        "
                            )
                          ])
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "well dialog__default--delete" },
                      [
                        _c(
                          "p",
                          {
                            staticClass:
                              "dialog__default--message m-0 mt-1 semibold wordbreak"
                          },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.deleteMessage) +
                                "\n                    "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("CompassButton", {
                          staticClass: "ml-2 fright",
                          attrs: {
                            label: _vm.$t.__(
                              "preferences.Dunning.Plan.delete_dunning_plan"
                            ),
                            type: "primary-destructive",
                            disabled: !_vm.plan.deletable
                          },
                          on: {
                            click: function($event) {
                              _vm.confirmationVisible = true
                            }
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary"
                      },
                      on: {
                        click: function($event) {
                          _vm.planSettingVisible = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__("common.actions.save"),
                        type: "primary",
                        loading: _vm.loading
                      },
                      on: { click: _vm.update }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _vm._v(" "),
      _c("step", { attrs: { planId: _vm.plan.id, steps: _vm.plan.steps } }),
      _vm._v(" "),
      _c("CompassDialog", {
        attrs: {
          visible: _vm.confirmationVisible,
          size: "small",
          title: _vm.$t.__("preferences.Dunning.Plan.deleting_plan")
        },
        on: {
          "update:visible": function($event) {
            _vm.confirmationVisible = $event
          }
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function() {
              return [
                _c("div", { staticClass: "dialog__header" }, [
                  _vm._v("\n                +\n                "),
                  _c(
                    "div",
                    { staticClass: "dialog__header--close" },
                    [
                      _c("CompassIconButton", {
                        attrs: { icon: "close" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("close")
                          }
                        }
                      })
                    ],
                    1
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "default",
            fn: function() {
              return [
                _c("div", { staticClass: "dialog__default" }, [
                  _c(
                    "span",
                    { staticClass: "typographies-paragraph-medium-regular" },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            _vm.$l10n.__(
                              'Confirmez-vous vouloir supprimer le plan de relance "%(planName)s"',
                              {
                                planName: _vm.plan.name
                              }
                            )
                          ) +
                          "\n                "
                      )
                    ]
                  )
                ])
              ]
            },
            proxy: true
          },
          {
            key: "footer",
            fn: function() {
              return [
                _c(
                  "div",
                  { staticClass: "dialog__footer" },
                  [
                    _c("CompassButton", {
                      attrs: {
                        label: _vm.$t.__("common.actions.cancel"),
                        type: "secondary",
                        size: "medium"
                      },
                      on: {
                        click: function($event) {
                          _vm.confirmationVisible = false
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("CompassButton", {
                      staticClass: "ml-3",
                      attrs: {
                        label: _vm.$t.__("common.actions.delete"),
                        type: "primary-destructive",
                        size: "medium",
                        loading: _vm.loading
                      },
                      on: {
                        click: function($event) {
                          return _vm.confirmDelete(_vm.plan.id)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }